import * as ng from 'angular';

export class SMSMessageController implements ng.IController {
   static $inject = ['toast', '$uibModalInstance', 'message'];

   constructor(
      private toast,
      private $uibModalInstance,
      public message:string
   ) { }

   save():void {
      if (this.message.indexOf('{url}') == -1) {
         this.toast.error()
            .title('Error')
            .message('Your message must include {url} somewhere, please fix this issue.')
            .send();
      } else {
         this.$uibModalInstance.close(this.message);
      }
   }

   cancel():void {
      this.$uibModalInstance.dismiss('cancel');
   }
}

ng.module('e360')
   .controller('SMSMessageController', SMSMessageController);
